import { useEffect } from 'react'
import {
  ErrorBanner,
  type ErrorBannerProps,
} from '@components/ErrorPage/ErrorBanner'
import { EmptyHeader } from '@components/ErrorPage/EmptyHeader'

export function ErrorPage({ locale, language, code }: ErrorBannerProps) {
  useEffect(() => {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.documentElement.setAttribute('data-theme', 'dark')
    }
  }, [])

  return (
    <>
      <EmptyHeader locale={locale} />
      <ErrorBanner locale={locale} language={language} code={code} />
    </>
  )
}
